import { render, staticRenderFns } from "./FormMetaReportDatastudio.vue?vue&type=template&id=66bd0a49&lang=pug"
import script from "./FormMetaReportDatastudio.vue?vue&type=script&lang=js"
export * from "./FormMetaReportDatastudio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66bd0a49')) {
      api.createRecord('66bd0a49', component.options)
    } else {
      api.reload('66bd0a49', component.options)
    }
    module.hot.accept("./FormMetaReportDatastudio.vue?vue&type=template&id=66bd0a49&lang=pug", function () {
      api.rerender('66bd0a49', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tasks/datastudio/components/FormMetaReportDatastudio.vue"
export default component.exports